import { UiAppearance } from './appearance'

interface ResolveAppShellAppearanceProps {
  pathname: string
}

export function resolveAppShellAppearance ({
  pathname,
}: ResolveAppShellAppearanceProps): UiAppearance {
  return museumHomeRoutes.has(pathname) ? 'museumHome' : 'default'
}

const museumHomeRoutes = new Set([
  '/',
  '/faq',
  '/gallery',
  '/gallery/[slug]',
  '/organizers/[organizerId]',
  '/trophies',
  '/trophies/[trophyId]',
  '/auth/signin',
  '/auth/verify-request',
  '/auth/error',
])
